module.exports = __webpack_public_path__ + "media/images/march8/march8-template-ru-5f41e79074c9021bd00c4c6824038069.png";